import { BoxProps, FormLabel, HStack, Icon, Tooltip } from '@chakra-ui/react';
import React from 'react';

import { Icon as FaIcon } from 'packages/common-frontend/components/icons';

export const ConcentrationCalcFieldLabel = ({
  label,
  tooltip,
  ...rest
}: {
  label: string;
  tooltip?: string;
} & BoxProps) => {
  return (
    <HStack {...rest}>
      <FormLabel fontSize="sm" mb={0} mr={0}>
        {label}
      </FormLabel>
      {tooltip && (
        <Tooltip label={tooltip}>
          <Icon fontSize="sm">
            <FaIcon icon="circle-info" />
          </Icon>
        </Tooltip>
      )}
    </HStack>
  );
};
